export const agentsSubMenu = [{
  path: '/agents/list',
  component: () => import('@/views/agents/list.vue'),
  name: 'dealerManagement.agent.title',
  meta: {
    title: 'dealerManagement.agent.title',
    roles: ['Super Admin', 'Read Only', 'Regional Manager', 'Zonal Manager', 'Branch Manager'],
    noCache: true,
    icon: 'agent'
  }
}, {
  path: '/agents/edit/:id(\\d+)',
  component: () => import('@/views/agents/manage.vue'),
  name: 'dealerManagement.agent.manage',
  props: {
    isEdit: true
  },
  meta: {
    title: 'dealerManagement.agent.manage',
    noCache: true,
    activeMenu: '/agents/list',
    hidden: true
  }
}, {
  path: '/agents/add/',
  component: () => import('@/views/agents/manage.vue'),
  name: 'dealerManagement.agent.manage',
  props: {
    isEdit: false
  },
  meta: {
    title: 'dealerManagement.agent.manage',
    noCache: true,
    activeMenu: '/agents/list',
    hidden: true
  }
}];